export const CANVAS = {
  POPUP_ACTIVITY_CONNECTION: 'element-connector',
  CANVAS_LEFT_TOOLBAR_ACTIVITY: 'canvas-left-tool-bar-activity',
  CANVAS_LEFT_TOOLBAR_GROUP_ICON: 'canvas-left-tool-bar-group-icon',
  CANVAS_LEFT_TOOLBAR_MILESTONES_ICON: 'canvas-left-tool-bar-milestones-icon',
  EDITABLE_NAME_INPUT: 'editable-name-input',
  CANVAS_RIGHT_CLICK_MENU_ADD_ACTIVITY: 'canvas-right-click-menu-add-activity',
  CANVAS_LEFT_TOOLBAR_START_MILESTONE: 'canvas-left-toolbar-start-milestone',
  CANVAS_LEFT_TOOLBAR_INTERIM_MILESTONE: 'canvas-left-toolbar-interim-milestone',
  CANVAS_LEFT_TOOLBAR_END_MILESTONE: 'canvas-left-toolbar-end-milestone',
  GROUP_NODE: 'group-node',
  ACTIVITY_NODE: 'activity-node',
  INTERIM_MILESTONE_NODE: 'interim-milestone-node',
  FINISH_MILESTONE_NODE: 'finish-milestone-node',
  FINISH_MILESTONE_SCHEDULE_BTN: 'endMilestone-schedule-btn',
  TOP_NAV_SCHEDULE_BTN: 'topNav-scheduleBtn',
  SCHEDULE_UPDATED_POPUP_CONTAINER: 'scheduler-updated-popupContainer',
  SCHEDULE_POPUP_CONTAINER_CLOSE_ICON: 'closeIcon-scheduler-popupContainer',
  PROJECT_TITLE_TEXT: 'canvas-project-title-text',
  TOP_NAV_CRITICAL_PATH: 'top-nav-critical-path-btn',
  CRITICAL_PATH_ROW: 'critical-path-table-row',
  CRITICAL_PATH_TOGGLE_BTN: 'critical-path-toggle-btn',
  UGLY_EDGE_CONNECTOR: 'ugly-edge-connector-popup',
  TOP_NAV_FILTER_BTN: 'canvas-top-nav-filter-btn',
  TOP_NAV_FILTER_BTN_AUTO_ID: 'top-nav-filter-btn-auto-id',
  SEARCH_TREE_WRAPPER: 'search-tree-wrapper',
  NODE_DURATION_WRAPPER: 'node-duration-section',
  DURATION_UNIT: 'duration-unit',
  NODE_ID_DISPLAY: 'node-id-display',
  EDITABLE_ID_INPUT: 'editable-id-input',
  CONNECT_NODE: 'connect-node-wbs',
  ELEMENT_ACTIVITY: 'element-node-wbs',
  MINI_PROJECT_COLLAPSE_BTN: 'mini-project-collapse-btn',
  ACTIVITY_EXPAND_ICON: 'activity-expand-icon',
  MENU_CONTAINER: 'right-click-menu-container',
  EMBEDDED_RELATIONSHIPS_SECTION_TITLE: 'relationships-status-box-header-title',
  RELATIONSHIP_SECTION_ROW: 'relationship-section-row',
  RELATIONSHIP_SECTION_NAME_VALUE: 'relationship-section-node-name',
  RELATIONSHIP_TYPE_AND_LAG_RELATION: 'relationship-type-and-lag-relation',
  RELATIONSHIP_BOX_CLOSE_BUTTON: 'relationship-box-close-button',
  SECTION_ADD_LINK: 'relationship-section-add-link',
  PROJECT_MAIN_TITLE: 'project-main-title',
  NORMAL_NAME: 'normal-group-name',
  CANVAS_LEFT_TOOLBAR_TASK: 'canvas-left-toolbar-task',
  PROJECTS_SORT_MENU_OPTION: 'projects-sort-menu-option',
  PROJECTS_SORT_MENU: 'projects-sort-menu',
  VERSION_NODE_HEADER_NAME: 'version-node-header-name',
  VERSION_OPTIONS_MENU: 'version-three-dots-menu',
  MUI_MENU_ITEM_ROOT: 'version-menu-item',
  BUTTON_INFO_BTN: 'button-info-btn',
  FOOTER_INFO_DIALOG_MUI_BUTTON_TEXT_PRIMARY: 'footer-info-dialog-box-button-text-primary',
  PROJECT_INFO_PANEL_EDIT_ICON: 'project-info-panel-edit-icon',
  FILTER_BTN_NP: 'filter-btn-right-and-left-arrow',
  NAVIGATE_TO_PREVIOUS_FILTERED_ELEMENT: 'navigate-to-previous-filtered-element',
  BUTTON_NEXT_FILTER_ARROW: 'button-next-filter-arrow',
  CANVAS_LEFT_TOOLBAR_GROUP: 'canvas-left-toolbar-group',
  CANVAS_LEFT_TOOLBAR_MILESTONES: 'canvas-left-toolbar-milestones',
  CANVAS_LEFT_TOOLBAR_TEXT_BOX: 'canvas-left-toolbar-text-box',
  CANVAS_LEFT_TOOLBAR_IMAGE: 'canvas-left-toolbar-image',
  CANVAS_MENU_TRIGGER_POPPER: 'canvas-menu-trigger-popper',
  CANVAS_MENU_TRIGGER_BUTTON: 'canvas-menu-trigger-button',
  EDGE_MENU_TRIGGER_POPPER: 'edge-menu-trigger-popper',
  EDGE_MENU_TRIGGER_BUTTON: 'edge-menu-trigger-button',
  CANVAS_LEFT_BOTTOM_TOOLBAR_ACTIVITY_STATUS: 'canvas-left-bottom-toolbar-activity-status',
  CANVAS_LEFT_BOTTOM_TOOLBAR_ACTIVITY_DETAILS: 'canvas-left-bottom-toolbar-activity-details',
  CANVAS_LEFT_BOTTOM_TOOLBAR_ACTIVITY_RELATIONSHIPS: 'canvas-left-bottom-toolbar-activity-relationships',
  CANVAS_LEFT_BOTTOM_TOOLBAR_ACTIVITY_RELATIONSHIPS_ICON: 'canvas-left-bottom-toolbar-activity-relationships-icon',
  CANVAS_LEFT_BOTTOM_TOOLBAR_ACTIVITY_STATUS_ICON: 'canvas-left-bottom-toolbar-activity-status-icon',
  GANTT_RELATIONSHIPS_ICON: 'gantt-relationships-icon',
  BOTTOM_CTAS: 'bottom-list-header',
  SHARE_PROJECT_WRAP: 'share-project-wrap',
  BOOKMARK_ICON: 'bookmark-icon',
  SEARCH_ICON: 'bookmark-search-icon',
  MUI_INPUT_INPUT_FIND_BOOKMARK: 'input-find-bookmark',
  BOOKMARKS_WRAPPER_LIST: 'bookmarks-wrapper-list',
  ROW_WRAPPER_MENU_TEXT_LABEL: 'bookmark-sub-menu-text-label',
  CANVAS_RIGHT_CLICK_MENU_ADD_GROUP: 'canvas-right-click-menu-add-group',
  CANVAS_RIGHT_CLICK_MENU_PASTE: 'canvas-right-click-menu-paste',
  CANVAS_RIGHT_CLICK_MENU_LINKED_PASTE: 'canvas-right-click-menu-linked-paste',
  CANVAS_RIGHT_CLICK_MENU_PASTE_AS_NEW: 'canvas-right-click-menu-paste-as-new',
  CANVAS_RIGHT_CLICK_MENU_PASTE_AS_TEXT_BOX: 'canvas-right-click-menu-paste-as-textbox',
  TITLE_MESSAGE: 'data-date-title-message',
  PROJECT_INFO_PANEL_MAIN: 'project-info-panel-main',
  PROJECT_PANEL_TITLE_TEXT: 'project-panel-title-text',
  PROJECT_INFO_PANEL_DATE_CELL_VIEW: 'project-info-panel-date-cell-view',
  PROJECT_TITLE_INFO_ICON: 'project-title-info-icon',
  LIST_ITEM_STYLE: 'canvas-settings-list-item',
  TREE_DROPDOWN_BTN: 'tree-dropdown-btn',
  TREE_VIEW_CLOSE_DEFAULT_CLOSE_ICON: 'tree-view-default-close-icon',
  SELECT_DEFAULT_COLOR_ICON: 'select-color-for-activity-arrow-icon',
  ZOOM_VALUE_TEXT: 'zoom-value-text',
  BOOKMARK_TITLE: 'bookmark-title-text',
  NODE_BOTTOM_ADDITIONAL_INFO_VALUE: 'node-bottom-float-and-critical-path-info-value',
  SAVED_BOOKMARK_TITLE: 'saved-bookmark-title-text',
  NODE_DATE_NODE_END_DATE: 'node-end-date',
  MILESTONE_START_NODE: 'milestone-start-node',
  BOOKMARK_DETAILS_BOOKMARK_DESCRIPTION: 'saved-bookmark-description',
  MORE_MENU_MORE_MENU_ICON: 'bookmark-more-menu-icon',
  TOOLTIP_WRAPPER: 'bookmark-tooltip-icon',
  STYLED_TOOLTIP: 'bookmark-tooltip-text',
  CRITICAL_PATHS_TABLE_COLUMN: 'critical-paths-table-column',
  CRITICAL_PATH_TEXT: 'critical-path-text',
  CRITICAL_PATH_CHECKBOX_LABEL: 'selected-float-path-checkbox-label',
  CANVAS_SETTINGS_FORM_FIELD_ITEM: 'canvas-settings-form-field-item',
  NODE_DATES: 'node-dates-at-top',
  NODE_START_DATE: 'node-start-date-at-top',
  NODE_DATE_FIELD: 'node-date-field-at-top',
  GROUP_DATES: 'wbs-header-dates',
  MILESTONE_TOP_ADDITIONAL_INFO: 'milestone-top-additional-info',
  REACT_FLOW_EDGE_CLICKABLE_CHILD: 'react-flow-edge-clickable-child',
  COLOR_PICKER_WRAP: 'left-panel-color-picker-container',
  COLOR_CIRCLE: 'color-circle',
  MILESTONE_START_NODE_CANVAS_ICON: 'milestone-start-node-canvas-icon',
  MILESTONE_INTERIM_NODE_CANVAS_ICON: 'milestone-interim-node-canvas-icon',
  MILESTONE_END_NODE_CANVAS_ICON: 'milestone-end-node-canvas-icon',
  BUTTON_INFO_ICON: 'button-info-icon',
  CONNECT_STUB_CORNER: 'connect-stub-corner',
  GROUP_NODE_COUNTS: 'group-node-counts',
  GROUP_CHILD_ACTIVITIES_COUNT: 'group-child-activities-count',
  PEEK_WBS_DIALOG_SEARCH_INPUT: 'combo-box-popup-search-input',
  PEEK_WBS_DIALOG_CLOSE_ICON: 'combo-box-popup-close-icon',
  PEEK_ACTIVITY_DIALOG_CONTENTS: 'inspecting-activity-path-dialog-box',
  FILTERED_OUT_ELEMENT_ACTIVITY: 'inspecting-element-name',
  TRACE_PATH_DIALOG_CLOSE_BUTTON: 'trace-path-dialog-close-button',
  AUTO_LAYOUT_DIALOG_CONTENTS: 'auto-layout-dialog-contents',

  FILTER_BOX: {
    SELECT_FIELD_DROPDOWN_MENU: 'filter-field-dropdown-menu',
    SELECT_FIELD_DROPDOWN_MENU_ITEM: 'filter-field-dropdown-menu-items',
    FILTER_STATUS_BAR: 'filter-status-bar',
    ADD_CONDITION_BTN: 'filter-box-add-condition-btn',
    DELETE_ICON: 'filter-box-delete-icon',
    CHECK_BOX: 'filter-check-box',
    ALL_CONDITIONS_DELETE_ICON: 'filter-box-all-conditions-delete-icon',
    FIELD_DROPDOWN_ARROW_ICON: 'filter-field-dropdown-arrow-icon',
    SELECTED_FIELD_DROPDOWN_BTN: 'filter-selected-field-dropdown-btn',
    FIELD_SELECTING_DROPDOWN_BTN: 'filter-field-dropdown-btn',
    FIELD_DROPDOWN_MENU_ITEM_TEXT: 'filter-field-dropdown-menu-item-text',
    OPERATOR_DROPDOWN: 'filter-operator-dropdown',
    CALENDAR_PARAM_DROPDOWN: 'filter-calendar-param-dropdown',
    PARAM_DROPDOWN_MENU_ITEM: 'filter-param-dropdown-menu-item',
    FOOTER_ELEMENTS_COUNT: 'filter-elements-count-footer',
    SAVE_FILTER_BTN: 'save-filter-btn',
    SAVE_CHANGES_FILTER_BTN: 'save-changes-filter-btn',
    SAVE_AS_NEW_FILTER_BTN: 'save-as-new-filter-btn',
    SAVE_FILTER_NAME_INPUT: 'save-filter-name-input',
    SAVE_FILTER_NAME_SAVE_BTN: 'save-filter-name-save-btn',
    SAVE_FILTER_NAME_CANCEL_BTN: 'save-filter-name-cancel-btn',
    RENAME_FILTER_SAVE_BTN: 'rename-filter-save-btn',
    RENAME_FILTER_CANCEL_BTN: 'rename-filter-cancel-btn',
    NEW_FILTER_SAVE_BTN: 'new-filter-save-btn',
    CREATE_NEW_FILTER_BTN_INSIDE_SAVED_FILTER: 'create-new-filter-btn-inside-saved-filters',
    SAVED_FILTER_OPTION: 'saved-filter-option',
    CONTEXT_MENU_ICON: 'context-menu-icon',
    MENU_TEXT_LABEL: 'menu-text-label',
    CONFIRM_PRIMARY_BTN: 'confirm-primary-btn',
    NEW_STYLE_BLANK_BTN: 'new-style-blank-btn',
    STATUS_NOT_STARTED: 'status-not-started',
    STATUS_IN_PROGRESS: 'status-in-progress',
    STATUS_COMPLETED: 'status-completed',
    CONTEXT_MENU_CONTAINER_TICK_ICON: 'saved-filters-tick-icon'
  },
  WBS: {
    GROUP_HEADER: 'mini-project-header',
    MINI_PROJECT_HEADER_NAME: 'miniProject-headerName',
    GROUP_MINIMIZE_ICON: 'group-minimize-icon'
  },
  LEFT_SIDE_BAR: {
    TABLE_ICON: 'sidebar-table-icon',
    CANVAS_ICON: 'sidebar-canvas-icon',
    GANTT_ICON: 'sidebar-gantt-icon',
    HOME_BTN: 'sidebar-home-btn',
    LABOR_BTN: 'sidebar-labor-btn',
    EQUIPMENT_BTN: 'sidebar-equipment-btn',
    WATCHLIST_BTN: 'sidebar-watchlist-btn',
    DCMA_COMPLIANCE_BTN: 'sidebar-dcma-compliance-btn',
    SIMULATIONS_BTN: 'sidebar-simulations-btn',
    TIMESPAN_RESOURCES_BTN: 'sidebar-timespan-resources-btn',
    VERSIONS_BTN: 'sidebar-versions-btn',
    INTERCOM_BTN: 'sidebar-intercom-btn',
    // ListItemText data-testids
    PLANERA_LABEL_TEXT: 'sidebar-planera-label-text',
    ALL_PROJECTS_TEXT: 'sidebar-all-projects-text',
    PROJECT_DASHBOARD_TEXT: 'sidebar-project-dashboard-text',
    CANVAS_TEXT: 'sidebar-canvas-text',
    TABLE_TEXT: 'sidebar-table-text',
    GANTT_TEXT: 'sidebar-gantt-text',
    WATCHLIST_TEXT: 'sidebar-watchlist-text',
    DCMA_COMPLIANCE_TEXT: 'sidebar-dcma-compliance-text',
    RISK_SIMULATION_TEXT: 'sidebar-risk-simulation-text',
    LABOR_USAGE_TEXT: 'sidebar-labor-usage-text',
    EQUIPMENT_USAGE_TEXT: 'sidebar-equipment-usage-text',
    TIMESPAN_RESOURCES_TEXT: 'sidebar-timespan-resources-text',
    PROJECT_COMPARE_TEXT: 'sidebar-project-compare-text',
    VERSION_TEXT: 'sidebar-version-text'
  },
  BOTTOM_TOOL_BAR: {
    FIT_TO_SCREEN_BTN: 'canvas-bottom-toolbar-fitToScreen-btn',
    UNDO_BTN: 'canvas-bottom-toolbar-undo-btn',
    ZOOM_OUT_BTN: 'canvas-bottom-toolbar-zoom-out-btn',
    SETTINGS_ICON: 'canvas-bottom-toolbar-settings-icon',
    RIGHT_TOOLS: 'canvas-bottom-toolbar-tools'
  },
  CONTEXT_MENU: {
    RIGHT_CLICK_CONTEXT_MENU: 'right-click-context-menu',
    CONTEXT_MENU_TEXT: 'context-menu-text',
    COLOR_PICKER: 'context-color-menu',
    COLOR_PICKER_RIGHT_ARROW: 'context-menu-color-picker-right-arrow',
    BULK_ACTION_RIGHT_ARROW: 'context-menu-bulk-action-right-arrow',
    GO_TO_ELEMENT: 'context-menu-go-to-element',
    COMMENT: 'context-menu-comment',
    CONVERT_TO_GROUP: 'context-menu-convert-to-group',
    CONVERT_TO_INTERIM_MILESTONE: 'context-menu-convert-to-interim-milestone',
    UNGROUP: 'context-menu-ungroup',
    COPY: 'context-menu-copy',
    MOVE: 'context-menu-move',
    CONNECT_IN_FS: 'context-menu-connect-in-fs',
    ALIGN_LEFT: 'context-menu-align-left',
    ALIGN_TOP: 'context-menu-align-top',
    AUTO_LAYOUT: 'context-menu-auto-layout',
    DISSOLVE_ELEMENT: 'context-menu-dissolve-element',
    INSERT_NEW_ELEMENT: 'context-menu-insert-new-element',
    NAVIGATE_TO_TABLE: 'context-menu-navigate-to-table',
    NAVIGATE_TO_GANTT: 'context-menu-navigate-to-gantt',
    INSPECT_PATH: 'context-menu-inspect-path',
    ACTIVITY_STATUS: 'context-menu-activity-status',
    TASK_STATUS: 'context-menu-task-status',
    FIND_AND_REPLACE_MENU: 'context-menu-find-and-replace',
    ADD_TO_WATCHLIST: 'context-menu-add-to-watchlist',
    REMOVE_FROM_WATCHLIST: 'context-menu-remove-from-watchlist',
    SHOW_CHANGELOG: 'context-menu-show-changelog',
    POPULATE_WBS: 'context-menu-populate-wbs',
    DELETE_ELEMENTS: 'context-menu-delete-elements',
    DELETE_ELEMENTS_CONFIRM_MODAL_CANCEL_BUTTON: 'canvas-delete-elements-confirm-modal-cancel-button',
    DELETE_ELEMENTS_CONFIRM_MODAL_DELETE_BUTTON: 'canvas-delete-elements-confirm-modal-delete-button',
    DELETE_ELEMENTS_CONFIRM_MODAL_DESCRIPTION: 'canvas-delete-elements-confirm-modal-description',
    DELETE_ELEMENTS_CONFIRM_MODAL_TITLE: 'canvas-delete-elements-confirm-modal-title',
    COPY_LINK_TO_ELEMENT: 'context-menu-copy-link-to-element',
    FIND_AND_REPLACE: {
      FIND_INPUT: 'find-name-input',
      REPLACE_INPUT: 'replace-name-input',
      RENAME_BTN: 'find-and-replace-rename-btn'
    }
  },
  EDGE_CONTEXT_MENU: {
    COLOR_PICKER_BTN: 'edge-context-menu-color-btn',
    UNPIN_EDGE_ICON: 'edge-context-menu-unpin-edge-icon',
    INSERT_ELEMENT: 'edge-context-menu-insert-element',
    DELETE_ELEMENT: 'edge-context-menu-delete-element',
    RELATIONSHIPS: 'edge-context-menu-relationships',
    LAG_TYPE_VALUE: 'relationship-type-menu-item-text',
    CHECKBOX_INPUT: 'relationship-type-checkbox-input',
    LAG_TYPE_INPUT: 'relationship-type-lag-input',
    LAG_TYPE_WRAPPER: 'relationship-type-lag-wrapper',
    LAG_TYPE_CHECKBOX: 'relationship-type-toggle-checkbox',
    RELATIONSHIP_DELETE_DIALOG_BOX_FOOTER: 'relationship-delete-dialog-box-footer',
    EDGE_CONTEXT_MENU_CONTAINER: 'edge-context-menu-container',
    EDGE_CONTEXT_MENU_DROPDOWN_ICON: 'edge-context-menu-relationship-type-dropdown-icon',
    EDGE_CONTEXT_MENU_SWITCH_WRAP: 'edge-context-menu-switch-wrap',
    RELATIONSHIP_TYPE_LIST_WRAPPER: 'edge-context-menu-relationship-type-list-wrapper',
    EDGE_CONTEXT_MENU_BOX: 'edge-context-menu-box',
    EDGE_CONTEXT_MENU_RELATIONSHIP_DROPDOWN_ICON: 'edge-context-relationship-dropdown',
    EDGE_CONTEXT_MENU_TOGGLE_BUTTON: 'edge-context-toggle-button',
    MULTI_EDGE_CONTEXT_MENU: 'multi-edge-context-menu',
    UGLY_EDGE_CONNECTIONS: 'ugly-edge-connections-popup',
    SWITCH_DIRECTION: 'edge-context-menu-switch-direction'
  },
  CHANGELOG: {
    TITLE_TEXT: 'changeLog-history-title-text',
    HISTORY_POPUP_CONTAINER: 'changeLog-history-popupContainer',
    SELECTED_ELEMENT_NAME: 'changeLog-selected-elementName',
    HISTORY_DIALOG_CLOSE_BTN: 'changeLog-history-close-icon',
    USER_NAME_ITEM: 'changeLog-history-user-name-list-text',
    COMBO_SEARCH_BOX: 'changeLog-history-combo-search-box',
    SEARCH_INPUT_FIELD: 'changeLog-history-search-input-field',
    DATE_FILTER_WRAP: 'changeLog-history-date-filter-wrap'
  },

  // Canvas main/base wrappers
  CANVAS_MAIN_WRAPPER: 'canvas-main-wrapper',
  CANVAS_TASK_BASE_PAGE: 'canvas-task-base-page',
  CANVAS_GROUP_BASE_PAGE: 'canvas-group-base-page',

  // Group elements
  CANVAS_GROUP_HEADER_TITLE: 'canvas-group-header-title',
  GROUP_NODE_FOOTER: 'canvas-group-node-footer',
  EXPAND_GROUP_ICON: 'canvas-expand-group-icon',
  NEW_GROUP_EXPAND_ICON: 'canvas-new-group-expand-icon',

  // History / trace path
  HISTORY_BOX: 'canvas-history-box',
  CHANGE_HISTORY_BOX: 'canvas-change-history-box',
  INSPECTING_PATH_BOX: 'canvas-inspecting-path-box',
  TRACE_PATH_POPUP_CLOSE: 'canvas-trace-path-popup-close',
  HISTORY_BOX_TITLE: 'canvas-history-box-title',
  HISTORY_BOX_ELEMENT_NAME: 'canvas-history-box-element-name',

  // Filters
  FILTER_OPTION_MENU: 'canvas-filter-option-menu',
  FILTER_ACTIVE_STATUS_BAR: 'canvas-filter-active-status-bar',
  FILTER_INACTIVE_STATUS_BAR: 'canvas-filter-inactive-status-bar',
  FILTER_CHECK_BOX: 'canvas-filter-check-box',
  CREATE_NEW_FILTER_OPTION: 'canvas-create-new-filter-option',
  DROPDOWN_OPTION: 'canvas-dropdown-option',

  // Contextual menus
  LASSO_SELECTION_CONTEXTUAL_MENU: 'canvas-lasso-selection-contextual-menu',
  CONTEXTUAL_MENU_CONTAINER: 'contextual-menu-container',
  CONTEXTUAL_MENU_BOX_ELEMENTS: 'contextual-menu-box-elements',
  LASSO_SELECTION_CONTEXT_MENU_SAFE: 'lasso-selection-context-menu',
  ACTIVITY_CONTEXTUAL_MENU_COLOR_LIST_SAFE: 'activity-contextual-menu-color-list',

  // Critical paths
  CRITICAL_PATHS_TABLE_ROW: 'critical-paths-table-row',
  CRITICAL_MODAL_TOGGLE_LIST: 'critical-modal-toggle-list',
  CRITICAL_MODAL_ROW: 'critical-modal-row',
  CRITICAL_MODAL_TOGGLE: 'critical-modal-toggle',
  RED_DOT: 'critical-path-red-dot',
  CP_BOX: 'critical-path-box',
  CP_TAG_ON_THE_CP_BOX: 'critical-path-tag-on-box',
  CP_TEXT_INSIDE_THE_CP_BOX: 'critical-path-text-inside-box',
  CRITICAL_PATH_LEVEL_1: 'critical-path-level-1',
  CRITICAL_PATH_LEVEL_2: 'critical-path-level-2',
  CP_WITHIN_THE_ELEMENT_NAME_CELL: 'critical-path-within-element-name-cell',
  CP_TAG_PILL: 'critical-path-tag-pill',

  // Combo search
  COMBO_SEARCH_POPUP: 'canvas-combo-search-popup',
  COMBO_SEARCH_BOX_LIST_ITEM: 'combo-search-list-item',
  COMBO_SEARCH_BOX_FOOTER: 'canvas-combo-search-box-footer',
  COMBO_SEARCH_BOX_ADD_BUTTON: 'combo-search-add-button',
  EXPANDED_ELEMENTS_OF_GROUP: 'combo-expanded-group-elements',

  // Color picker
  COLOR_PICKER_MENU_CORE: 'color-picker-menu',
  COLOR_CIRCLE_PICKER: 'color-circle-picker',
  COLOR_PICKER_SECTION_LEFT_PANEL: 'color-picker-section-left-panel',
  SELECT_ACTIVITY_DEFAULT_COLOR: 'select-activity-default-color',
  RIGHT_CLICK_MENU_CONTAINER: 'right-click-menu-container',

  // Project creation dialog
  PROJECT_CREATION_ORGANIZATION_DROPDOWN: 'project-creation-organization-dropdown',
  PROJECT_CREATION_DIALOG_LEFT_SECTION: 'project-creation-dialog-left-section',
  PROJECT_CREATION_THUMBNAIL_ICONS: 'project-creation-thumbnail-icons',
  PROJECT_CREATION_COLOR_SECTION: 'project-creation-color-section',
  PROJECT_CREATION_THUMBNAIL_PREVIEW: 'project-creation-thumbnail-preview',

  // Export dialog
  EXPORT_PROJECT_STEP_LABEL: 'export-project-step-label',
  EXPORT_SELECTION_OPTION: 'export-selection-option',
  EXPORT_FORMAT_CARD: 'export-format-card',
  EXPORT_DIALOG_DESCRIPTION: 'export-dialog-description',
  EXPORT_FINAL_REVIEW_CARD: 'export-final-review-card',
  EXPORT_FORMAT_TITLE_LABEL: 'export-format-title-label',
  EXPORT_SELECTED_FORMAT_TICK: 'export-selected-format-tick',

  // Organization selector
  ORGANIZATION_SELECTOR_ITEM: 'organization-selector-item',

  // Resource library
  RESOURCE_LIBRARY_LABOR_TAB: 'resource-library-labor-tab',
  RESOURCE_LIBRARY_EQUIPMENT_TAB: 'resource-library-equipment-tab',
  RESOURCE_ACTIONS_MENU_CONTAINER: 'resource-actions-menu-container',
  RESOURCE_INFO_ICON: 'resource-info-icon',
  RESOURCE_ARCHIVE_BUTTON: 'resource-archive-button',
  RESOURCE_MORE_OPTIONS_ICON: 'resource-more-options-icon'
} as const;
